import ReactSimpleCurrency from 'react-simple-currency';
import React from 'react';
import PropTypes from 'prop-types';

const CustomTip = ({ onChange, onSubmit, tip, increment, decrement }) => (
  <form className="c-payment-modal-tip-custom" onSubmit={onSubmit}>
    <div className="c-payment-modal-tip-custom__input">
      <span>$</span>
      <ReactSimpleCurrency
        className="c-input"
        type="number"
        min="0"
        required
        value={tip}
        onInputChange={onChange}
      />
    </div>
    <div className="c-payment-modal-tip-custom__controls">
      <button type="button" onClick={decrement}>−</button>
      <button type="button" onClick={increment}>+</button>
    </div>
    <button className="c-payment-modal-tip-custom__submit" disabled={tip < 0}>Set</button>
  </form>
);

CustomTip.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  tip: PropTypes.number.isRequired,
};

export default CustomTip;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymentModalCustomTip.jsx